import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ComparisonPanel = ({ players, onRemovePlayer, onClearAll, onClose }) => {
  if (players?.length === 0) return null;

  const metrics = [
    { key: 'age', label: 'Age', suffix: 'yrs' },
    { key: 'marketValue', label: 'Market Value', prefix: '€', suffix: 'M' },
    { key: 'rating', label: 'Rating', suffix: '/10' },
    { key: 'goals', label: 'Goals', suffix: '' },
    { key: 'assists', label: 'Assists', suffix: '' },
    { key: 'appearances', label: 'Appearances', suffix: '' }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-card border-t border-border shadow-elevated">
      <div className="max-w-7xl mx-auto p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Icon name="GitCompare" size={20} color="var(--color-primary)" />
            <h3 className="text-base md:text-lg font-semibold text-foreground font-headline">
              Player Comparison ({players?.length}/4)
            </h3>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={onClearAll}
              iconName="X"
              iconPosition="left"
            >
              Clear All
            </Button>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-md transition-colors"
              aria-label="Close comparison"
            >
              <Icon name="ChevronDown" size={20} />
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <div className="flex gap-4 min-w-max">
            {players?.map((player) => (
              <div key={player?.id} className="w-64 bg-muted rounded-lg p-4 space-y-3">
                <div className="relative">
                  <div className="aspect-[3/4] rounded-lg overflow-hidden mb-3">
                    <Image
                      src={player?.image}
                      alt={player?.imageAlt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <button
                    onClick={() => onRemovePlayer(player?.id)}
                    className="absolute top-2 right-2 p-1 bg-destructive text-destructive-foreground rounded-full hover:bg-destructive/90 transition-colors"
                    aria-label="Remove player"
                  >
                    <Icon name="X" size={16} />
                  </button>
                </div>

                <div>
                  <h4 className="font-semibold text-foreground mb-1">{player?.name}</h4>
                  <p className="text-xs text-muted-foreground">{player?.position}</p>
                </div>

                <div className="space-y-2">
                  {metrics?.map((metric) => (
                    <div key={metric?.key} className="flex justify-between text-sm">
                      <span className="text-muted-foreground">{metric?.label}</span>
                      <span className="font-medium text-foreground">
                        {metric?.prefix}{player?.[metric?.key]}{metric?.suffix}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {players?.length < 4 && (
              <div className="w-64 bg-muted/50 border-2 border-dashed border-border rounded-lg p-4 flex flex-col items-center justify-center text-center">
                <Icon name="Plus" size={32} color="var(--color-muted-foreground)" className="mb-2" />
                <p className="text-sm text-muted-foreground">
                  Add up to {4 - players?.length} more {players?.length === 3 ? 'player' : 'players'}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonPanel;